import Alpine from 'alpinejs'
import qsa from '../../helpers/qsa'

// Determine PQ/PA banner language based on categories
const handleCategories = categories => {
  const targetCategories = {
    2811: 'preapproved', // Pre-Approval
    2474: 'prequal', // Pre-Qualified
    2662: 'prequal', // Pre-Qualified No Disclosure
    2479: 'specialOffer' // CardMatch™ Special Offers
  }

  categories.forEach(cat => {
    if (targetCategories[cat.id]) {
      cat.rankings.forEach(card => {
        const originalPID = Alpine.store('approval_odds').pidMaps[
          card.product_id
        ]
        if (originalPID && Alpine.store(`pid_${originalPID}`)) {
          // Append categories
          Alpine.store(`pid_${originalPID}`).updateCategory(
            targetCategories[cat.id],
            true
          )
        }
      })
    }
  })
}

const updateProductStore = (results, collationIdPidMap) => {
  for (const [key, value] of Object.entries(results.data.approvalOdds)) {
    if (Alpine.store(`pid_${key}`)) {
      // Set the approval odd value.
      Alpine.store(`pid_${key}`).updateOdd(value)
      // Tell state that this card now has an approval odd.
      Alpine.store(`pid_${key}`).updateHasOdd(true)
      Alpine.store(`pid_${key}`).updateTooltipContent(value)
      Alpine.store(`pid_${key}`).updateAoColor(value)
      collationIdPidMap[Alpine.store(`pid_${key}`).collationId] = key
    }
  }
}

const updateToOfferProducts = (offers, collationIdPidMap, approvalOdds) => {
  offers.forEach(offer => {
    const attributes = offer.attributes
    const collationId = attributes.collationId
    const offerProductBox = document.querySelector(
      `[data-collation-id="${collationId}"]`
    )

    if (offerProductBox) {
      // Don't run offer logic on excluded issuers.
      if (offerProductBox.hasAttribute('data-ao-excluded-issuer')) {
        return
      }

      const issuerName = offerProductBox.getAttribute('data-issuer-name')
      // Flag card store as an AO offer.
      let pid =
        collationIdPidMap[collationId] ||
        offerProductBox.getAttribute('data-product-id')

      Alpine.store(`pid_${pid}`).updateIsAoOffer()

      // For mobile best cards.
      const sectionCategory = Alpine.store(`pid_${pid}`).category
      if (sectionCategory) {
        qsa(`[data-slider-cat="${sectionCategory}"]`).forEach(el => {
          el.classList.add('ao-prequal-banner--bc-mobile')
        })
      }

      // Store the intro offer.
      // TODO: verify that the offer is the first element, no other offers in this array.
      const introBonusesArray = attributes.introBonuses
      if (introBonusesArray.length > 0) {
        const introBonus = introBonusesArray[0]
        Alpine.store(`pid_${pid}`).updateIntroOffer(introBonus.displayText)
        Alpine.store(`pid_${pid}`).updateIntroOfferDescription(
          introBonus.description
        )
      }

      // Update the pids with the new one received in the offers.
      const legacyId = attributes.legacyId
      offerProductBox.setAttribute('data-product-id', legacyId)
      offerProductBox.setAttribute('data-beam-correlation-id', legacyId)
      offerProductBox.setAttribute('data-beam-id', legacyId)
      offerProductBox.setAttribute('data-beam-product-id', legacyId)

      // Update pidMads in global store.
      Alpine.store('approval_odds').updatePidMaps(legacyId, pid)

      // Update the odd from marketplace card to offer card odd.
      if (approvalOdds[legacyId]) {
        const odd = approvalOdds[legacyId]
        Alpine.store(`pid_${pid}`).updateOdd(odd)
        Alpine.store(`pid_${pid}`).updateHasOdd(true)
        Alpine.store(`pid_${pid}`).updateTooltipContent(odd)
        Alpine.store(`pid_${pid}`).updateAoColor(odd)
      }

      // Updating the pids for mobile accordions.
      const dataPidLocations = qsa(
        `[data-collation-id="${collationId}"] .accordion__title-container`
      )
      dataPidLocations.forEach(accordion => {
        accordion.setAttribute('data-beam-id', legacyId)
        accordion.setAttribute('data-beam-correlation-id', legacyId)
        accordion.setAttribute('data-beam-product-id', legacyId)
      })

      // Store the regular APR and annual fee.
      const regularApr = attributes.aprs.find(
        apr => apr.name === 'Ongoing Purchases APR'
      )
      Alpine.store(`pid_${pid}`).updateRegularApr(regularApr.displayText)

      const annualFee = attributes.fees.find(
        fee => fee.name === 'Ongoing Annual Fee'
      )
      Alpine.store(`pid_${pid}`).updateAnnualFee(annualFee.displayText)

      // Update the rates and fees links.
      const rateAndFeesLink = offerProductBox.querySelector('.terms-link')
      offerProductBox.setAttribute(
        'data-sticky-banner-terms',
        attributes.termsAndConditionsUrl
      )
      if (rateAndFeesLink) {
        rateAndFeesLink.setAttribute('href', attributes.termsAndConditionsUrl)
        rateAndFeesLink.setAttribute(
          'data-beam-outbound-url',
          attributes.termsAndConditionsUrl
        )
        rateAndFeesLink.setAttribute('data-beam-id', legacyId)
        rateAndFeesLink.setAttribute('data-beam-correlation-id', legacyId)
        rateAndFeesLink.setAttribute('data-beam-product-id', legacyId)
      }

      // Update the Card Art, Title, and Apply now links and pids
      const applyButtons = qsa(
        `[data-collation-id="${collationId}"] [data-apply-button]`
      )
      applyButtons.forEach(button => {
        button.setAttribute('data-link', attributes.link)
        button.setAttribute('data-outbound-url', attributes.link)
        button.setAttribute('data-correlation-id', legacyId)
        button.setAttribute('data-beam-product-id', legacyId)
        button.setAttribute('data-product-id', legacyId)

        // If Amex add attribute to determine link logic in `bankrate-tracking/credit-cards.js`
        if (issuerName === 'American Express') {
          button.setAttribute('data-amex-special-offer', 'true')
        }

        // For Card Art.
        const cardArt = button.querySelector('img')
        if (cardArt) {
          cardArt.setAttribute('data-link', attributes.link)
          cardArt.setAttribute('data-outbound-url', attributes.link)
          cardArt.setAttribute('data-product-id', legacyId)
          // If Amex add attribute to determine link logic in `bankrate-tracking/credit-cards.js`
          if (issuerName === 'American Express') {
            cardArt.setAttribute('data-amex-special-offer', 'true')
          }
        }

        // For Card Name Headers.
        const cardName = button.querySelector('.js-product-box__title')
        if (cardName) {
          cardName.setAttribute('data-link', attributes.link)
          cardName.setAttribute('data-outbound-url', attributes.link)
          cardName.setAttribute('data-product-id', legacyId)
          // If Amex add attribute to determine link logic in `bankrate-tracking/credit-cards.js`
          if (issuerName === 'American Express') {
            cardName.setAttribute('data-amex-special-offer', 'true')
          }
        }
      })

      // Get rid of the mobile "Bankrate's view" accordion.
      // (Cannot be done via blade / Alpine since modifying the shared accordions.blade.php doesn't seem like a good idea.)
      const mobileBankratesView = offerProductBox.querySelector(
        `[data-beam-text="Bankrate's view"]`
      )
      if (mobileBankratesView) {
        mobileBankratesView.parentElement.classList.add('+display-none')
      }

      // Get rid of desktop version of "Bankrate's view" accordion.
      const desktopBankratesView = offerProductBox.querySelector(
        '.bankrates-view'
      )
      if (desktopBankratesView) {
        desktopBankratesView.classList.add('+display-none')
      }

      // Apply the rewards rate to the rewards rate accordion.
      const rewardRates = attributes.rewardRates
      Alpine.store(`pid_${pid}`).updateRewardRates(rewardRates)

      // Get the min and max ranges of the reward rates (array is sorted in descending order).
      if (rewardRates.length > 0) {
        const minRate = rewardRates[rewardRates.length - 1].displayText
        const maxRate = rewardRates[0].displayText
        const rateRange =
          minRate === maxRate ? minRate : minRate + '-' + maxRate
        Alpine.store(`pid_${pid}`).updateRateRange(rateRange)
      }

      // Update the "additional features" box in the card details accordion.
      const purchaseAprObject = attributes.aprs.find(
        apr => apr.name === 'Introductory Purchases APR'
      )
      const purchaseAprText = purchaseAprObject
        ? purchaseAprObject.displayText
        : 'N/A'

      const purchaseAprPeriodValue = purchaseAprObject
        ? purchaseAprObject.periodValue
        : ''

      const purchaseAprPeriodUnit = purchaseAprObject
        ? purchaseAprObject.periodUnit
        : ''
      Alpine.store(`pid_${pid}`).updatePurchaseApr(purchaseAprText)
      Alpine.store(`pid_${pid}`).updatePurchaseAprPeriodValue(
        purchaseAprPeriodValue
      )
      Alpine.store(`pid_${pid}`).updatePurchaseAprPeriodUnit(
        purchaseAprPeriodUnit
      )

      const balanceAprObject = attributes.aprs.find(
        apr => apr.name === 'Introductory Balance Transfer APR'
      )
      const balanceAprText = balanceAprObject
        ? balanceAprObject.displayText
        : 'N/A'

      const balanceAprPeriodValue = balanceAprObject
        ? balanceAprObject.periodValue
        : ''

      const balanceAprPeriodUnit = balanceAprObject
        ? balanceAprObject.periodUnit
        : ''

      Alpine.store(`pid_${pid}`).updateBalanceApr(balanceAprText)
      Alpine.store(`pid_${pid}`).updateBalanceAprPeriodValue(
        balanceAprPeriodValue
      )
      Alpine.store(`pid_${pid}`).updateBalanceAprPeriodUnit(
        balanceAprPeriodUnit
      )

      // Apply the bullets to the card details accordion.
      Alpine.store(`pid_${pid}`).updateBullets(attributes.bullets)
    }
  })
}

export default function displayResults() {
  // Grab results from session storage.
  const results = JSON.parse(sessionStorage.getItem('approvalOdds'))
  // Grabbing array of special offers being returned.
  const offers = results.data?.products?.data
  const categories = results.data?.categories
  const approvalOdds = results.data?.approvalOdds
  const collationIdPidMap = {}
  // Add each product to store as it's own instance.
  updateProductStore(results, collationIdPidMap)

  // Update product boxes with new prequal product data.
  if (offers && offers.length > 0) {
    updateToOfferProducts(offers, collationIdPidMap, approvalOdds)
  }

  // Prequal/Preapproved banner logic.
  if (categories && categories.length) {
    handleCategories(categories)
  }

  // Update products array in approval_odds store.
  Alpine.store('approval_odds').products.forEach(product => {
    if (Alpine.store(`pid_${product.pid}`)) {
      product.odd = Alpine.store(`pid_${product.pid}`).odd
    }
  })
}
